import axiosInstance from '../config/axios.config';
import ENDPOINTS from '../config/endpoints';

const checkoutService = {
  // Create a new checkout
  async createCheckout(userUuid) {
    try {
      const response = await axiosInstance.post(ENDPOINTS.CHECKOUT.CREATE, {
        user_uuid: userUuid
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get checkout details
  async getCheckout(checkoutUuid, userUuid) {
    try {
      const response = await axiosInstance.post(ENDPOINTS.CHECKOUT.GET, {
        uuid: checkoutUuid,
        user_uuid: userUuid
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get shipping rates for the selected address
  async getShippingRates(checkoutUuid, addressUuid, userUuid) {
    try {
      const response = await axiosInstance.post(ENDPOINTS.CHECKOUT.RATES, {
        user_uuid: userUuid,
        checkout_uuid: checkoutUuid,
        address_uuid: addressUuid
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Commit the shipping rate the user picked
  async selectRate(checkoutUuid, rateId) {
    try {
      const response = await axiosInstance.post(ENDPOINTS.CHECKOUT.SELECT_RATE, {
        checkout_uuid: checkoutUuid,
        rate_id: rateId
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default checkoutService;
